import React from 'react';
import '../components/grammar-page.css';
import { FaLightbulb, FaListUl, FaLanguage, FaBookOpen } from 'react-icons/fa';

const ThereIsThereAreExplanation = () => {
  return (
    <div className="grammar-explanation">
      <h2><FaBookOpen /> A1 - There is / There are</h2>
      <p>We use <strong>there is</strong> and <strong>there are</strong> to say that something exists or to talk about where things are.</p>

      <h3><FaLightbulb /> Affirmative</h3>
      <ul>
        <li><strong>There is</strong> a book on the table. (singular)</li>
        <li><strong>There are</strong> two chairs in the room. (plural)</li>
      </ul>

      <h3><FaLightbulb /> Contractions</h3>
      <ul>
        <li>There is = <strong>There's</strong> a cat on the sofa.</li>
        <li>There are = <strong>There're</strong> some apples in the bowl. (less common in speech, but sometimes used)</li>
      </ul>

      <h3><FaLightbulb /> Negative</h3>
      <ul>
        <li><strong>There isn't</strong> any milk in the fridge.</li>
        <li><strong>There aren't</strong> any buses at this time.</li>
      </ul>

      <h3><FaListUl /> Questions</h3>
      <ul>
        <li><strong>Is there</strong> a bank near here?</li>
        <li><strong>Are there</strong> any shops open today?</li>
      </ul>

      <h3><FaLanguage /> Short Answers</h3>
      <ul>
        <li>Yes, <strong>there is</strong>. / No, <strong>there isn't</strong>.</li>
        <li>Yes, <strong>there are</strong>. / No, <strong>there aren't</strong>.</li>
      </ul>

      <h3><FaLanguage /> Using 'some' and 'any'</h3>
      <ul>
        <li>Affirmative: There are <strong>some</strong> oranges on the table.</li>
        <li>Negative & Questions: There aren't <strong>any</strong> eggs left. / Are there <strong>any</strong> eggs left?</li>
      </ul>

      <h3><FaLanguage /> Using 'a / an'</h3>
      <ul>
        <li>There's <strong>a</strong> pen on the desk.</li>
        <li>There's <strong>an</strong> umbrella by the door.</li>
      </ul>

      <h3><FaBookOpen /> Common Uses</h3>
      <ul>
        <li>To say something exists: <em>There are many people here.</em></li>
        <li>To talk about location: <em>There's a key on the table.</em></li>
        <li>To ask about places: <em>Is there a pharmacy near here?</em></li>
      </ul>
    </div>
  );
};

export default ThereIsThereAreExplanation;
